import { render, staticRenderFns } from "./RPKeywordActionRecord.vue?vue&type=template&id=cd5af8b0"
import script from "./RPKeywordActionRecord.vue?vue&type=script&lang=js"
export * from "./RPKeywordActionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports